interface UnlinkConfirmProps {
  label: string;
  onCancel: () => void;
  onConfirm: () => void;
  isSubmitting: boolean;
}

export function UnlinkConfirm({
  label,
  onCancel,
  onConfirm,
  isSubmitting,
}: UnlinkConfirmProps) {
  return (
    <div
      role="alertdialog"
      aria-modal="true"
      data-testid="unlink-confirm"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/30"
    >
      <div className="w-[min(420px,90vw)] rounded-[10px] bg-surface-primary p-4 shadow-lg border border-border-secondary">
        <h4 className="text-content-primary text-[14px] font-semibold mb-2">
          Unlink {label}?
        </h4>
        <p className="text-content-secondary text-[12px] mb-4">
          This user will return to single-property behavior. If the group ends
          up with only one remaining member, it will be dissolved automatically.
        </p>
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="text-[12px] font-medium px-3 py-1.5 rounded-md border border-border-primary text-content-primary hover:bg-surface-secondary/50"
          >
            Cancel
          </button>
          <button
            type="button"
            disabled={isSubmitting}
            onClick={onConfirm}
            data-testid="unlink-confirm-button"
            className="text-[12px] font-medium px-3 py-1.5 rounded-md bg-danger text-content-inverse hover:opacity-90 disabled:opacity-50"
          >
            {isSubmitting ? "Unlinking…" : "Unlink"}
          </button>
        </div>
      </div>
    </div>
  );
}
